import * as mutationTypes from './../store/mutation-types.js'
import globalStore from '@/store/index.js'

let instance = null

export default class HelperService {
  constructor () {
    if (!instance) {
      instance = this
    }
    return instance
  }

  groepIdsBepalenAlsArray (groepen) {
    let klIds = []
    let kgIds = []
    let leIds = []
    for (let x = 0; x < groepen.length; x++) {
      let groep = groepen[x]
      switch (groep.Type) {
        case 'klas':
          klIds.push(groep.ID)
          break
        case 'klasgroep':
          kgIds.push(groep.ID)
          break
        case 'leseenheid':
          leIds.push(groep.ID)
          break
      }
    }
    return [klIds, kgIds, leIds]
  }

  fotosOphalen (lijst) {
    for (var i = 0; i < lijst.length; i++) {
      var huidigeLln = lijst[i]
      var foto = ''
      var LLID = huidigeLln.LL_ID
      if (LLID !== null && LLID !== undefined) {
        var hexString = (LLID).toString(16).toLowerCase()
        var pad = '00000000'
        var ans = pad.substring(0, pad.length - hexString.length) + hexString + '.png'
        foto = globalStore.state.userInfo.loggedInUserInformation.SessionConfig.FotoURL + 'leerling/small/' + ans
      } else {
        foto = '/static/pics/no_photo.png'
      }
      huidigeLln.LL_FOTOURL = foto
      huidigeLln.fotoExists = true
    }
    return lijst
  }

  groepIdsBepalen (groepen) {
    var groepIdsBepalenAlsArray = this.groepIdsBepalenAlsArray(groepen)
    let klIds = groepIdsBepalenAlsArray[0]
    var kgIds = groepIdsBepalenAlsArray[1]
    var leIds = groepIdsBepalenAlsArray[2]
    klIds = klIds.toString()
    if (klIds === '') {
      klIds = '-1'
    }
    kgIds = kgIds.toString()
    if (kgIds === '') {
      kgIds = '-1'
    }
    leIds = leIds.toString()
    if (leIds === '') {
      leIds = '-1'
    }
    return [klIds, kgIds, leIds]
  }

  setLeerlingAfwezigheid (lijst, leerling, afwezigheid) {
    console.log('setLeerlingAfwezigheid')
    for (var x = 0; x < lijst.length; x++) {
      var huidigeLln = lijst[x]
      if (huidigeLln.LL_ID === leerling.LL_ID) {
        huidigeLln['AFW_CODE'] = afwezigheid
      }
    }
    // this.$store.state.commit(types.ZET_BESTAANDE_LEERLING_LIJST, { list: lijst }) niet nodig?
  }

  setAllLeerlingenStatus (lijst, status) {
    console.log('setAllLeerlingenStatus')
    for (var x = 0; x < lijst.length; x++) {
      var huidigeLln = lijst[x]
      huidigeLln['AFW_CODE'] = status
    }
    // this.$store.state.commit(types.ZET_BESTAANDE_LEERLING_LIJST, { list: lijst })niet nodig?
  }

  nietsIngegeven (lijst) {
    console.log('nietsIngegeven')
    var nietsIngegeven = true
    for (var x = 0; x < lijst.length; x++) {
      var huidigeLln = lijst[x]
      if ((huidigeLln.AFW_CODE !== ' ' || huidigeLln.AFW_CODE_DATABANK !== ' ') && (huidigeLln.AFW_CODE !== null || huidigeLln.AFW_CODE_DATABANK !==
          null)) {
        nietsIngegeven = false
        break
      }
    }
    return nietsIngegeven
  }

  isIetsGewijzigd (lijst) {
    console.log('isIetsGewijzigd')
    var ietsGewijzigd = false
    for (var x = 0; x < lijst.length; x++) {
      var huidigeLln = lijst[x]
      if (huidigeLln.AFW_CODE !== '' && huidigeLln.AFW_CODE !== huidigeLln.AFW_CODE_DATABANK) {
        ietsGewijzigd = true
        break
      }
    }
    return ietsGewijzigd
  }

  isNietsIngegeven (lijst) {
    console.log('isNietsIngegeven')
    var nietsIngegeven = true
    for (var x = 0; x < lijst.length; x++) {
      var huidigeLln = lijst[x]
      if (huidigeLln.AFW_CODE !== null && huidigeLln.AFW_CODE !== undefined) {
        nietsIngegeven = false
        break
      }
    }
    return nietsIngegeven
  }

  errorOccuredAfhandelingLeerlingen () {
    setTimeout(function () {
      console.log('leerlingen herladen')
      globalStore.dispatch('wstudent/' + 'getLeerlingen')
    }, 2000)
  }

  

  guiLijstUpdatenAanDbWaarden (lijst) {
    for (var x = 0; x < lijst.length; x++) {
      var huidigeLln = lijst[x]
      huidigeLln.AFW_CODE_DATABANK = huidigeLln.AFW_CODE
    }
  }

  typeGroepInteger (typeGroep) {
    typeGroep = typeGroep.replace(/\s+/g, '')
    if (typeGroep.toLowerCase() === 'leseenheid') {
      return 2
    } else if (typeGroep.toLowerCase() === 'klasgroep') {
      return 1
    } else if (typeGroep.toLowerCase() === 'klas') {
      return 0
    }
  }

  afwezigheidscodesLesuurBepalen (lijst, uur) {
    console.log('afwezigheidscodesLesuurBepalen')
    for (var i = 0; i < lijst.length; i++) {
      var huidigeLln = lijst[i]
      if (huidigeLln.AFW_CODE_DATABANK === undefined) {
        var str = 'niet gevonden'
        switch (uur + '') {
          case '8':
            str = huidigeLln.AW_UUR8
            break
          case '7':
            str = huidigeLln.AW_UUR7
            break
          case '6':
            str = huidigeLln.AW_UUR6
            break
          case '5':
            str = huidigeLln.AW_UUR5
            break
          case '4':
            str = huidigeLln.AW_UUR4
            break
          case '3':
            str = huidigeLln.AW_UUR3
            break
          case '2':
            str = huidigeLln.AW_UUR2
            break
          case '1':
            str = huidigeLln.AW_UUR1
            break
        }
        huidigeLln.AFW_CODE = str
        huidigeLln.AFW_CODE_DATABANK = str
      }
    }
    return lijst
  }

  wijzigMetOfZonderInstellingen (config) {
    console.log('wijzigMetOfZonderInstellingen')
  }
}
